import React from "react";  
import { BrowserRouter } from "react-router-dom";

import App from "./App";

// import locationParser from "./util/locationParser";

class AppState extends React.Component {
  state = {
    appState: {
      activeAction: "HOME",
      update: (action) => this.appStateUpdate(action),
    },
    appNavState: {
      active: false,
      clicked: () => this.appNavClicked(),
      toggle: () => this.appNavToggle(),
    },
  };

  appStateUpdate = (action) => {
    let tempAppState = { ...this.state.appState };
    tempAppState.activeAction = action;
    console.log(tempAppState.activeAction);
    this.setState({ appState: tempAppState });
  };

  appNavToggle = () => {
    let newnAppNavState = this.state.appNavState;
    newnAppNavState.active = !newnAppNavState.active;
    this.setState({ appNavState: newnAppNavState });
  };

  appNavClicked = () => {
    let newnAppNavState = this.state.appNavState;
    if (newnAppNavState.active) {
      newnAppNavState.active = !newnAppNavState.active;
    }
    this.setState({ appNavState: newnAppNavState });
  };

  render() {
    return (
      <BrowserRouter>
        <App {...this.state} />
      </BrowserRouter>
    );
  }
}

export default AppState;
